import React from 'react';
import _get from 'lodash/get';

import { withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import MedicareAccountForm from 'components/account/health-fund-accounts/MedicareAccountForm';
import Page from 'components/account/layout/Page';
import WithAuthentication from 'components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'utils/health-fund-accounts';
type Props = {
  history: Record<string, any>;
};

class CreateMedicareAccount extends React.PureComponent<Props> {
  handleAddMedicareAccount = async (medicareAccount: Record<string, any>) => {
    const { history } = this.props;

    const memberId = _get(sdk, 'member._id');

    const body = await updateMembersHealthFundAccount({
      healthFundAccount: medicareAccount,
      memberId,
    });
    history.push('/account/members');
    return body;
  };
  handleClickCancel = () => {
    window.history.back();
  };
  render = () => (
    <WithAuthentication>
      <Page minWidthBreakpoint="mobile" title="Add Medicare card">
        <MedicareAccountForm
          onClickCancel={this.handleClickCancel}
          onSubmit={this.handleAddMedicareAccount}
          title="Add Medicare card"
        />
      </Page>
    </WithAuthentication>
  );
}

export default withRouter(CreateMedicareAccount);
